module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "blog"
  }, [_c('div', {
    staticClass: "background"
  }, [_c('background-vector', {
    staticClass: "blog__vector",
    attrs: {
      "alpha": 0.15,
      "scale": _vm.background.scale,
      "viewbox": _vm.background.viewbox,
      "rotate": -40
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "background__banner blog__banner"
  }, [_vm._v(_vm._s(_vm.content.banner))])], 1), _vm._v(" "), (_vm.useCats) ? _c('blog-filters') : _vm._e(), _vm._v(" "), _c('div', {
    ref: "feed",
    staticClass: "blog__content",
    class: _vm.classes
  }, [_c('transition', {
    attrs: {
      "name": "feed"
    }
  }, [_c('router-view', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFeed),
      expression: "showFeed"
    }],
    attrs: {
      "featured": _vm.content.featured
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "post"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "post",
      "use-history": _vm.useHistory
    },
    on: {
      "toggle-post": function($event) {
        _vm.showFeed = !_vm.showFeed
      }
    }
  })], 1)], 1), _vm._v(" "), _c('header-nav', {
    attrs: {
      "modifier": "blog"
    }
  }), _vm._v(" "), _c('footer-nav', {
    attrs: {
      "sidebars": _vm.sidebars
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7226d5fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/blog/Blog.vue
// module id = 643
// module chunks = 1